<div class="grid" *ngIf="carInformacionInicial">
  <div class="col-12 md:col-12 lg:col-12 text-center">
    <i class="fa fa-refresh fa-spin fa-3x fa-fw"></i><br>
    <span>{{'LBL_CONSULTANDO' | translate }}</span>
  </div>
</div>
<div *ngIf="!carInformacionInicial">
  <div class="grid">
    <div class="col-12 md:col-12 lg:col-12">
      <form [formGroup]="formulario" (ngSubmit)="onSubmit()" novalidate id="idForm" name="nomForm">

        <div class="grid form-group">
          <div class="col-12 md:col-4 lg:col-4">
            <div class="div-form">
              <label>{{'PLAGA.LBL_PLAGA' | translate}}: </label>
              <label class="falso-combo-texto"><b>{{ plaga.nombre }}</b></label>
            </div>
          </div>

          <div class="col-12 md:col-4 lg:col-4 md:col-offset-1 lg:col-offset-1">
            <label>{{'PLAGA.LBL_PRODAGRICOLA' | translate}}:</label>
            <p-dropdown disableTab  id="idProductoAgricola" name="nomIdProductoAgricola" [options]="lisProductoAgricola"
                        placeholder="{{ 'LBL_SELECCIONE' | translate}}"
                         formControlName="idProductoAgricola"
                        emptyFilterMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                        emptyMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                        optionValue="value"
                        optionLabel="label"
            ></p-dropdown>
            <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && f.idProductoAgricola.invalid">
              {{ 'PLAGA.LBL_PRODAGRICOLA' | translate}} {{ 'LBL_REQUERIDO' | translate}}
            </div>
          </div>

          <div class="col-12 md:col-3 lg:col-3">
            <div class="div-form">
              <p-checkbox formControlName="indicadorHabilitado" binary="true"></p-checkbox>
              <label>{{'LBL_HABILITADO' | translate}}</label>
            </div>
          </div>
        </div>


        <div class="grid form-footer-buttons">
          <div class="form-group col-12">
            <div *ngIf="!guardando">
              <button icon="fa fa-plus" label="{{'BTN_GUARDAR' | translate }}"
                      type="submit" *ngIf="!plagaProducto"
                      pButton></button>
              <button icon="fa fa-plus" label="{{'BTN_ACTUALIZAR' | translate }}"
                      type="submit" *ngIf="plagaProducto"
                      pButton></button>
            </div>
            <div *ngIf="guardando">
              <i class="fa fa-refresh fa-spin fa-2x fa-fw"></i><br>
              <span>{{'LBL_GUARDANDO' | translate }}</span>
            </div>
          </div>
        </div>

      </form>
    </div>
  </div>

  <div class="grid">
    <div class="col-12 md:col-12 lg:col-12">
      <p-table [columns]="columnas" [loading]="carTabla" #dt
               [value]="lisPlagaProducto" selectionMode="single" dataKey="idPlagaProductoAgricola"
               [paginator]="true" [rows]="10"  paginatorPosition="bottom">
        <ng-template pTemplate="header" let-columns>
          <tr>
            <th *ngFor="let col of columns" [pSortableColumn]="col.field" [pSortableColumnDisabled]="!col.sort" class="text-center">
              {{col.header}}
              <p-sortIcon [field]="col.field" *ngIf="col.sort"></p-sortIcon>
            </th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-row>
          <tr [pSelectableRow]="row">
            <td class="table-break">{{row.productoAgricola}}</td>
            <td class="text-center">
              <p-checkbox [(ngModel)]="row.indicadorHabilitado" binary="true" disabled="true"></p-checkbox>
            </td>
            <td class="text-center">
              <div class="btn-group" role="group">
                <button type="button" class="p-button p-button-success btn" icon="fa fa-pencil" data-toggle="tooltip"
                        title="{{'BTN_EDITAR' | translate}}" pButton *ngIf="menu.editar"
                        (click)="editar(row)"></button>
              </div>
            </td>
          </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage" let-columns>
          <tr>
            <td [attr.colspan]="columns.length" class="text-center">
              {{ 'MSG_NOHAYREGISTROS' | translate}}
            </td>
          </tr>
        </ng-template>
      </p-table>
    </div>
  </div>

</div>
<p-confirmDialog #cd>
  <ng-template pTemplate="footer">
    <button type="button" pButton icon="fa fa-close" label="{{ 'LBL_NO' | translate }}" (click)="cd.reject()"></button>
    <button type="button" pButton icon="fa fa-check" label="{{ 'LBL_SI' | translate }}" (click)="cd.accept()"></button>
  </ng-template>
</p-confirmDialog>
